import { Amplify } from 'aws-amplify';
import { config } from './config';

/** Configure Amplify Auth (Cognito) from runtime config. Call once at startup. */
export function configureAmplify() {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.userPoolId,
        userPoolClientId: config.userPoolClientId,
        loginWith: { email: true },
      },
    },
  });
}
